import React from 'react'
import Link from 'gatsby-link'
import resolveLink from '../../utils/resolveLink'
import SbEditable from 'storyblok-react'
import Logo from "/static/logo_dark.svg"
import { Popover } from '@headlessui/react'
import MobileMenu from './MobileMenu'
import MenuItemPopup from './MenuItemPopup'
import CartButton from './CartButton'
import { StoreContext } from "src/context/store-context"

const Navigation = ({settings}) => {

  const { didJustAddToCart } = React.useContext(StoreContext)

  return (
    <Popover id="navbar" className="sticky top-0 bg-white z-50 duration-300">
      <Link className="flex cursor-pointer items-center justify-center text-base text-white text-center font-display uppercase bg-red px-[16px] py-[10px] transition duration-300 block tlfcustom:hidden" to={resolveLink("/cx-insights-hub/")}><i className="far fa-search mr-2"></i> Search the hub</Link>
      <div className="absolute inset-0 z-30 shadow pointer-events-none" aria-hidden="true" />
      <div className="relative">
        <div className="max-w-[1440px] mx-auto flex justify-between items-end lg:px-16 px-6 lg:pt-5 pt-4 xl:space-x-10 space-x-5">
          <Link className="flex lg:pb-5 pb-4" to={resolveLink("/")}>
            <span className="sr-only">TLF Research</span>
              <img
                className="lg:h-14 h-12"
                src={Logo}
                alt="TLF Research"
              />
          </Link>
          <div className="hidden tlfcustom:flex tlfcustom:items-center tlfcustom:justify-center">
            <Popover.Group as="nav" className="flex xl:space-x-10 space-x-5 items-end">
              {settings.content.header_navigation.map((item) => {
                if (item.submenu.length > 0) {
                  return (
                    <SbEditable content={item} key={item._uid}>
                      <MenuItemPopup {...item}/>
                    </SbEditable>
                  )
                } else {
                    return (
                      <SbEditable content={item} key={item._uid}>
                        <>
                          <Link to={resolveLink(`/${item.target.cached_url}`)} className="group inline-block font-display pb-4 leading-none text-lg hover:text-red hover:border-red border-b-2 border-transparent focus:outline-none outline-none duration-300 text-center">
                            {item.name}
                          </Link>
                        </>
                      </SbEditable>
                    )
                }
              })}
            </Popover.Group>
          </div>
          <div className="flex text-lg lg:pb-5 pb-4 text-darkgrey items-center">
            <Link className="flex cursor-pointer items-center text-base text-white leading-none font-display uppercase bg-red hover:bg-darkred px-[16px] pt-[11px] pb-[9px] mr-2 transition duration-300 hidden tlfcustom:block" to={resolveLink("/cx-insights-hub/")}><i className="far fa-search fa-sm mr-1"></i> Search the hub</Link>
              <CartButton />
              <MobileMenu {...settings}/>
          </div>
        </div>
      </div>
      <div className={`bg-red font-display text-sm text-white text-center py-2 absolute top-full w-full transition-all overflow-hidden duration-500 origin-top ${didJustAddToCart ? "scale-y-100 opacity-100 visible" : "scale-y-0 opacity-0 invisible"}`}>Item added to your basket!</div>
    </Popover>
  )
};

export default Navigation;